import { LegacyAccountUser } from '@/api/queries/me/toLegacyAccountUser';
import { useAccountUsers } from '@/api/queries/me/useAccountUsers';

export const useAccountUser = (
  userId?: number
): LegacyAccountUser | undefined => {
  const accountUsers = useAccountUsers();
  if (userId) {
    const user = accountUsers?.find((x) => x.id === userId);
    return user;
  }
};
